import type { NskResponse } from "~/models/Api";
import type { DealTodoEdit } from "~/models/DealTodo";
import {
	deleteRequest,
	postRequest,
	putRequest
} from "~/utils/api/api_handler";

const paths = {
	create: "/deals/:deal_id/deal_todos",
	destroy: "/deals/:deal_id/deal_todos/:id",
	update: "/deals/:deal_id/deal_todos/:id"
};

export const create = async (
	dealId: number,
	dealTodo: DealTodoEdit
): Promise<NskResponse> =>
	postRequest(paths.create.replace(":deal_id", String(dealId)), {
		dealTodo
	});

export const update = async (
	dealId: number,
	dealTodoId: number,
	dealTodo: DealTodoEdit
): Promise<NskResponse> =>
	putRequest(
		paths.update
			.replace(":deal_id", String(dealId))
			.replace(":id", String(dealTodoId)),
		{ dealTodo }
	);

export const destroy = async (
	dealId: number,
	dealTodoId: number
): Promise<NskResponse> =>
	deleteRequest(
		paths.destroy
			.replace(":deal_id", String(dealId))
			.replace(":id", String(dealTodoId))
	);
